/* eslint-disable */
import axios from "axios";

// Módulo para obtener las paradas
const baseUrl = process.env.VUE_APP_BASE_API + "/excursion/stop-schedules/";

const state = {
  stops: [],
  stopsAdmin: []
};

const actions = {
  // Cargar paradas
  loadStops({
    commit
  }, data) {
    axios
      .get(baseUrl + '?activity_group=' + data.activity_group)
      .then(r => r.data)
      .then(stops => {
        commit("SET_STOPS", stops);
      });
  },

  // Mover parada
  async moveStops({
    commit,
    dispatch
  }, data) {
    await axios.patch(`${baseUrl}${data.id}/move_order_up_down/`, data.params);
    dispatch("bookings/loadBookingsByStop", data.booking, {
      root: true
    });
  },

  async changeHour({
    commit
  }, payload) {
    await axios
      .patch(baseUrl + `${payload.id}/change_hour/`, payload.data)
  },

  async loadStopsAdmin({
    commit
  }, data) {
    await axios
      .get(
        baseUrl + 'list_all/' +
        '?activity_group_id=' + data.activity_group_id
      ).then(r => r.data)
      .then(stops => {
        commit("SET_STOPS_ADMIN", stops)
      })
  },

  async copyFromActivityGroupId({
    commit, dispatch
  }, data) {
    await axios
      .post(
        baseUrl + 'copy_from/',
        data
      )
    dispatch("groups/loadGroups", {}, {root: true})
  },

  async updateStopSchedule({
    commit, dispatch
  }, data) {
    await axios
      .patch(
        baseUrl + data.stop_schedule_id + '/',
        data.payload
      )
      .then(response => {
        return response.data
      })
  },

  async deleteStopSchedule({
    commit, dispatch
  }, data) {

    return axios
      .delete(
        baseUrl + data.stop_id + '/'
      )
      
  },

  async reorderStopScheduleOrder({
    commit, dispatch
  }, data) {
    let stops = this.getters.stopsAdmin
    let length = stops.length
    let stopToMove = stops[data.oldIdx-1] // see comment on else if
    let newOrder = 0
    
    if ( data.newIdx > length -1) {
      // go to the last element
      // get the previous element
      let previousStop = stops[data.newIdx ]
      newOrder = previousStop.order + 100
      
    } else if ( data.newIdx == 1 ) { // 1 because table has sub element to differentiate subzones inside the same table
      // go to the first element
      let nextStop = stops[0]
      newOrder = Math.round(nextStop.order / 2) 
    } else {
      let nextStop = stops[data.newIdx]
      let previusStop = stops[data.newIdx-1]
      newOrder = Math.round( (nextStop.order + previusStop.order) / 2)
    }

    // update
    const dataToUpdate = {
      stop_schedule_id: stopToMove.id,
      payload: {
        order: newOrder
      }
    }
    await dispatch("updateStopSchedule", dataToUpdate)
  },

  async createStopScheduleAtPosition({
    commit, dispatch
  }, data) {
    await axios
      .post(baseUrl + 'create_at/',
        data.payload
      ).then(response => {
        return response.data
      })
  }

  
};

const mutations = {
  SET_STOPS(state, stops) {
    state.stops = stops;
  },
  SET_STOPS_ADMIN(state, stops) {
    state.stopsAdmin = stops
  },
  RESET_STOPS_ADMIN(state) {
    state.stopsAdmin = []
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};